import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { useMediaQuery } from "react-responsive";
import { ClipLoader } from "react-spinners";
import { getWalletAction } from "../../../../../redux/action/wallet";
import { PayDeposit } from "../../../../../redux/action/confirmLotspayment";
import Skeleton from "react-loading-skeleton";
import ConfirmServicePaymentTable from "../tables/ConfirmServicePaymentTable";

function ConfirmServiceLotPayment() {
  const { id, auctionId } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [offers, setOffers] = useState([
    {
      offer: "",
      EMDAmount: "",
    },
  ]);

  const isDastop = useMediaQuery({ query: "(max-width: 1500px)" });
  const [checkedValue, setCheckedValue] = useState([]);
  const [paymentAmount, setPaymentAmount] = useState("000");
  const { confirmlotsPayment } = useSelector(
    (state) => state?.confirmPaymentsLots
  );
  const loadingValue = useSelector((state) => state.PayDeposits);
  const { wallet, loading } = useSelector((state) => state.wallet);

  const handlePayment = () => {
    const payload = { offers: offers };
    dispatch(PayDeposit(payload, id, navigate));
  };

  useEffect(() => {
    if (confirmlotsPayment?.length === 0) {
      navigate(-1);
    }
  }, [confirmlotsPayment, id, navigate]);

  useEffect(() => {
    dispatch(getWalletAction());
  }, [dispatch]);

  useEffect(() => {
    if (checkedValue) {
      const amount = checkedValue.reduce((total, item) => {
        return total + parseInt(item?.EMDAmount || 0, 10);
      }, 0);
      setPaymentAmount(amount);

      const userSelectLots = checkedValue.map((item, index) => ({
        offer: item?._id,
        EMDAmount: item?.EMDAmount,
      }));

      setOffers(userSelectLots);
    }
  }, [checkedValue]);

  return (
    <div className="flex column gap-1 ">
      <span className="valign-wrapper" style={{ gap: "25px" }}>
        <span
          className="material-icons-outlined pointer"
          onClick={() => navigate(-1)}
        >
          arrow_back
        </span>
        <h4>EMD Payment ( Auction ID: {auctionId} )</h4>
      </span>
      <div
        className={`${
          isDastop ? "" : "container"
        } cover white flex column gap-1`}
      >
        <div className="p-1 textAlign-center ">
          <h4 className="">EMD Payment</h4>
          <p className="cercle-purple-text mb-1">Confirm your Lots</p>
          <ConfirmServicePaymentTable
            checkedValue={checkedValue}
            setCheckedValue={setCheckedValue}
            totalItem={5}
          />
        </div>
        <hr />
        <div className="p-1 mb-1 valign-wrapper space-between flex-wrap">
          <div
            className={`cover  border valign-wrapper gap-1  justify-center `}
            style={{
              width: "370px",
              height: "125px",
            }}
          >
            <img
              className="circle border"
              style={{ padding: "16px", backgroundColor: "#f6ecff " }}
              src={`${process.env.PUBLIC_URL}/icons/wallet-2.svg`}
              alt="Icon"
            />

            <span>
              <b className="cercle-purple-text font-20px">Wallet Balance</b>
              <p
                className="black-text font-25px font-cercular-bold"
                style={{ marginTop: "-5px" }}
              >
                {" "}
                {loading ? <Skeleton /> : ` ₹ ${wallet?.availableBalance || "000"}`}
              </p>
            </span>
          </div>
          <div className="mr-2">
            <h5 className="cover p-1 margin-0px">
              Total Amount :
              <span> ₹ {paymentAmount + 0 * checkedValue?.length}</span>
            </h5>
            <p className="small-text cercle-purple-text">
              ₹ 0 Additional Fee to Participate in Auction
            </p>
          </div>
        </div>
        <div className="flex justify-center mb-2">
          <button
            className={`button-style pointer ${
              offers?.length === 0
                ? "grey  lighten-2"
                : "white-text cercle-purple"
            }`}
            style={{ padding: "12px 35px", bottom: "10px" }}
            disabled={offers?.length === 0}
            onClick={handlePayment}
          >
            {loadingValue?.loadings ? (
              <ClipLoader color="#fff" size={20} />
            ) : (
              "Pay"
            )}
          </button>
        </div>
      </div>
    </div>
  );
}

export default  ConfirmServiceLotPayment
;
